export * from './platform.module';
export * from './platform';
//# sourceMappingURL=index.js.map